import { DownOutlined, GlobalOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";

import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

const Language = () => {
  const { t } = useTranslation(["menus"]);

  const items = [
    {
      key: "11",
      label: "English",
    },
    {
      key: "12",
      label: "Thai",
    },
    {
      key: "13",
      label: "China",
    },
  ];

  const handleMenuClick = (e) => {
    if (e.key === "11") {
      i18n.changeLanguage("en");
    } else if (e.key === "12") {
      i18n.changeLanguage("th");
    } else if (e.key === "13") {
      i18n.changeLanguage("ch");
    }
  };

  return (
    <div>
      <Dropdown menu={{ items, onClick: handleMenuClick }} trigger={["hover"]}>
        <Space>
          <GlobalOutlined />
          {t("Menu_Language.Language")}
          <DownOutlined style={{ marginRight: "10px" }} />
        </Space>
      </Dropdown>
    </div>
  );
};

export default Language;
